// Core
import React, { useState, useRef, useEffect } from "react"
import { isMobile } from "react-device-detect"
import { localiseString } from "../../utils/localiseString"

// Components
import NewsletterForm from "../newsletterForm"

// Styles
import styles from "./notify.module.scss"

const Notify = ({ open, closeEvent }) => {
  const [currentHeight, setCurrentHeight] = useState(0)

  const wrap = useRef()

  const checkForSubstantialHeightChange = () => {
    if (
      window.innerHeight > currentHeight - 100 &&
      window.innerHeight < currentHeight + 100
    )
      return
    setHeight()
  }

  const setHeight = () => {
    wrap.current.style.height = window.innerHeight + "px"
  }

  useEffect(() => {
    if (isMobile) setHeight()
    if (isMobile)
      window.addEventListener("resize", checkForSubstantialHeightChange)

    return () => {
      if (isMobile)
        window.removeEventListener("resize", checkForSubstantialHeightChange)
    }
  }, [])

  return (
    <div
      className={`${styles.wrap} ${open === true ? styles.open : ""}`}
      onClick={closeEvent}
      ref={wrap}
    >
      <div
        className={styles.background}
        onClick={e => {
          e.stopPropagation()
        }}
      >
        <div className={styles.closeBtn} onClick={closeEvent}>
          <span />
          <span />
        </div>
        <div className={`${styles.inner} container`}>
          <div className={styles.closePanel} onClick={closeEvent}></div>
          <div className={styles.content}>
            <h6>{localiseString("Stay tuned")}</h6>
            <p>{localiseString("Be the first to know when new episodes drop")}</p>
            <NewsletterForm theme={`light`} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Notify
